<template>
  <v-dialog v-model="dialog" persistent width="700">
    <template v-slot:activator="{ on }">
      <v-tooltip v-if="Boolean(servicePlan)" bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" @click="openDialog" small color="primary"
            >mdi-pencil</v-icon
          >
        </template>
        <span>Edit Service Plan</span>
      </v-tooltip>

      <v-btn
        v-else
        v-on="on"
        @click="openDialog"
        rounded
        outlined
        small
        color="primary"
      >
        <v-icon small color="primary">mdi-plus</v-icon> New Service Plan</v-btn
      >
    </template>
    <v-card>
      <validation-observer ref="form" v-slot="{ invalid }">
        <v-card-title color="primary">
          Service Plan <v-spacer></v-spacer>
          <v-btn color="primary" icon @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn></v-card-title
        >
        <v-card-text
          ><v-row
            ><v-col cols="12" sm="6">
              <div class="pt-4">
                <date-picker
                  :field="{ label: 'Auth Start Date' }"
                  :value="form.startDate"
                  :validations="{
                    required: true,
                    minDate: plan.planStartDate,
                    maxDate: plan.closureDate,
                  }"
                  @fieldChange="form.startDate = $event"
                  :readonly="!canEdit"
                >
                </date-picker></div></v-col
            ><v-col cols="12" sm="6">
              <div class="pt-4">
                <date-picker
                  :field="{ label: 'Auth End Date' }"
                  :value="form.endDate"
                  :validations="{
                    required: true,
                    minDate: form.startDate,
                    maxDate: plan.closureDate,
                  }"
                  @fieldChange="form.endDate = $event"
                  :readonly="!canEdit"
                >
                </date-picker></div></v-col
          ></v-row>
          <v-row>
            <v-col cols="12" sm="4">
              <validation-provider rules="required" v-slot="{ errors }">
                <v-autocomplete
                  v-model="form.programId"
                  label="Program"
                  :items="programs"
                  :item-text="(item) => `${item.code} - ${item.name}`"
                  item-value="programId"
                  :error-messages="errors"
                  :clearable="canEdit"
                  :readonly="!canEdit"
                ></v-autocomplete>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="4">
              <validation-provider rules="required" v-slot="{ errors }">
                <v-autocomplete
                  v-model="form.serviceId"
                  label="Service"
                  :items="services"
                  :item-text="(item) => `${item.code} - ${item.name}`"
                  item-value="serviceId"
                  :error-messages="errors"
                  :clearable="canEdit"
                  :readonly="!canEdit"
                ></v-autocomplete>
              </validation-provider> </v-col
            ><v-col cols="12" sm="4">
              <validation-provider
                :rules="{ required: true }"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  v-model="form.sessionLocationId"
                  label="Location"
                  :items="locations"
                  :item-text="
                    (item) => `${item.legacyLocationId} - ${item.name}`
                  "
                  item-value="sessionLocationId"
                  :error-messages="errors"
                  :clearable="canEdit"
                  :readonly="!canEdit"
                ></v-autocomplete>
              </validation-provider> </v-col
          ></v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <validation-provider
                :rules="{ required: true }"
                v-slot="{ errors }"
              >
                <v-select
                  v-model="form.frequency"
                  :items="frequencies"
                  label="Frequency"
                  :error-messages="errors"
                  :clearable="canEdit"
                  :readonly="!canEdit"
                ></v-select>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3"
              ><validation-provider
                :rules="{ required: true }"
                v-slot="{ errors }"
              >
                <v-select
                  v-model="form.durationMinutes"
                  label="Duration"
                  :items="durations"
                  :error-messages="errors"
                  :clearable="canEdit"
                  :readonly="!canEdit"
                ></v-select>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3"
              ><validation-provider
                :rules="{ required: true }"
                v-slot="{ errors }"
                ><v-text-field
                  v-model.number="form.groupSize"
                  label="Group Size"
                  type="number"
                  min="1"
                  max="10"
                  :error-messages="errors"
                  :readonly="!canEdit"
                ></v-text-field></validation-provider
            ></v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model.number="form.unitCount"
                label="Unit Count"
                type="number"
                :readonly="!canEdit"
              ></v-text-field></v-col
          ></v-row>
          <v-row>
            <v-col cols="12" sm="4">
              <v-checkbox
                v-model="form.isLocationChangeAllowed"
                hide-details
                dense
                :readonly="!canEdit"
                disabled
                ><template v-slot:label>
                  <span style="font-size: 12px"
                    >SEIT Optional Location Change</span
                  >
                </template></v-checkbox
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions v-if="canEdit">
          <v-spacer></v-spacer>
          <v-btn small color="primary" text @click="closeDialog">Cancel</v-btn>
          <v-btn
            small
            color="primary"
            :disabled="invalid || loading"
            @click="save"
            >Save</v-btn
          >
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
import ServicePlan from "../../../objs/ServicePlan";
export default {
  props: ["planId", "servicePlan"],
  data() {
    return {
      dialog: false,
      loading: false,
      form: new ServicePlan(),
      frequencies: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      durations: [30, 60, 90],
    };
  },
  computed: {
    canEdit() {
      return (
        this.$store.getters["securityModule/isEIAdmin"] ||
        this.$store.getters["securityModule/isSEITAdmin"]
      );
    },
    programs() {
      return (
        this.$store.state.optionsModule.programs.sort((a, b) =>
          a.code.localeCompare(b.code)
        ) || []
      );
    },
    services() {
      return (
        this.$store.state.optionsModule.services.sort((a, b) =>
          a.code.localeCompare(b.code)
        ) || []
      );
    },
    locations() {
      return (
        this.$store.state.optionsModule.sessionLocations.sort((a, b) =>
          a.legacyLocationId.localeCompare(b.legacyLocationId)
        ) || []
      );
    },
    plan() {
      return this.$store.state.plansModule.plans.find(
        (item) => item.planId == this.planId
      );
    },
    clientId() {
      return this.plan.clientId;
    },
  },
  methods: {
    openDialog() {
      if (this.servicePlan) {
        // edit service plan
        this.form = { ...this.servicePlan };
        this.form.startDate = new Date(this.servicePlan.startDate);
        this.form.endDate = new Date(this.servicePlan.endDate);
      } else {
        // new service plan
        // default end date to 1 year after start date
        var startDate = new Date(this.plan.planStartDate);
        var defaultEndDate = new Date(
          new Date(startDate).setFullYear(startDate.getFullYear() + 1)
        );
        // don't set default to summer date for a 10 month plan
        var isDefaultDateDuringSummer =
          defaultEndDate.getMonth() == 6 || defaultEndDate.getMonth() == 7;
        if (
          this.plan.isSummerSemesterIncluded == false &&
          isDefaultDateDuringSummer
        ) {
          defaultEndDate = null;
        }
        this.form.endDate = defaultEndDate;
      }
      this.form.planId = this.planId;
      this.form.clientId = this.clientId;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.form = new ServicePlan();
    },
    async save() {
      this.loading = true;
      let message;
      // update
      if (this.servicePlan) {
        message = await this.$store.dispatch(
          "plansModule/updateServicePlan",
          this.form
        );
      } else {
        // create
        message = await this.$store.dispatch(
          "plansModule/createServicePlan",
          this.form
        );
      }
      if (message) {
        this.$store.commit("uxModule/setSnackbarMsg", message);
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Service plan saved successfully"
        );
      }
      this.loading = false;
      this.$store.commit("uxModule/setShowSnackbar", true);
      this.closeDialog();
    },
  },
};
</script>
